<div class="wrapper" *ngIf="router.url !== '/style-guide'; else styleGuideSection">
  @if (!isHeaderHidden()) {
    <app-header></app-header>
  }

  <div class="d-flex flex-row flex-grow-1">

    @if (!isSidebarHidden()) {
      <div [ngClass]="isCollapsed ? 'sidebar-wrapper collapsed' : 'sidebar-wrapper expanded'">
        <app-sidebar
          [isCollapsed]="isCollapsed"
          (collapsedChange)="toggleSidebar($event)"
        ></app-sidebar>
      </div>
    }

    <div class="d-flex flex-column flex-grow-1" style="min-width: 0;">
      <main class="bg-body-tertiary flex-grow-1 py-3">
        <div class="main-content-inner" [class.full-width]="isFullWidthPage()">
          <router-outlet></router-outlet>
        </div>
      </main>

      <app-footer class="px-0"></app-footer>
    </div>
  </div>
</div>

<ng-template #styleGuideSection>
  <router-outlet></router-outlet>
</ng-template>

<app-spinner></app-spinner>

<!-- AI Assistant FAB -->
<ai-chat
  *ngIf="activeMode === 'provider' && currentUser?.provider_id"
  [authData]="currentUser"
  layout="fab"
  [apiEndpoint]="aiApiEndpoint"
  [suggestEndpoint]="aiSuggestEndpoint"
  [providerId]="currentUser?.provider_id"
  enable-history="false"
  (logout)="handleLogout()"
  (close)="onAiChatClose()"
  (maximize)="onAiChatMaximize()"
  (newConversation)="onNewConversation()"
  (quoteListing)="onQuoteListing($event.detail)">
</ai-chat>
